require('backbone.paginator');
require('backbone-validation');
require('backbone.trackit');
Backbone.Validation.configure({
    forceUpdate: true
});

var EntitiesBase = require('./base');

var ModelBase = Backbone.Model.extend({
    initialize: function (attrs, options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                tracking: options && options.tracking ?
                    options.tracking :
                    self.collection &&
                    self.collection._trackingChanges
            }
        );

        self._trackingChanges = self.options.tracking;
        if (self._trackingChanges) {
            self.startTracking();
        }
        this.on('error', this.handleError.bind(this));
    },
    sync: function (method, model, options) {
        var beforeSend;
        var self = this;

        options = options || {};

        options.beforeSend = function (xhr) {

            if (method === 'read') {

                var fetchEnded = function () {
                    self.fetching = false;
                    self.trigger('fetch:end', self);
                    self.off('sync error', fetchEnded);
                    self.off('request', fetchStarted);
                };

                var fetchStarted = function (model, xhr) {
                    self.fetching = true;
                    self.trigger('fetch:start', self);
                };

                self.on('request', fetchStarted);
                self.on('sync error', fetchEnded);
                self.on('sync error', fetchEnded);
            }

            if (farmacy.settings.restAPI.nonce) {
                xhr.setRequestHeader('X-WP-Nonce', farmacy.settings.restAPI.nonce);
            }

            if (beforeSend) {
                return beforeSend.apply(self, arguments);
            }
        };

        // backbone.trackit changes added here because we're overriding sync
        // and so do they.
        // backbone.trackit changes start
        if (method == 'update' || method == 'create' || method == 'patch') {
            options.success = _.wrap(options.success, _.bind(function(oldSuccess, data, textStatus, jqXHR) {
              var ret;
              if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);
              if (model._trackingChanges) {
                model._resetTracking();
                model._triggerUnsavedChanges();
              }
              return ret;
            }, this));
        }
        // backbone.trackit changes end

        // Update the nonce when a new nonce is returned with the response.
        options.complete = function (xhr) {
            var returnedNonce = xhr.getResponseHeader('X-WP-Nonce');

            if (returnedNonce && farmacy.settings.restAPI.nonce !== returnedNonce) {
                farmacy.settings.restAPI.nonce = returnedNonce;
            }
        };
        return Backbone.sync( method, model, options );
    },
    handleError: function (model, resp, options) {
        var self = this;
        try {
            var errors = resp.validation;
            if (!errors) {
                return;
            }
            _.each(errors, function (val, attr) {
                _.each(model.associatedViews, function (view) {
                    Backbone.Validation.callbacks.invalid(view, attr, val.message, 'name');
                });
            });
            _.defer(function () {
                model.trigger('validated', false, model, errors);
                model.trigger('validated:invalid', model, errors);
            });
        } catch (error) {}
    },
    suppressValidationForAttribute: function (attr) {
        if (this.validation) {
            this.validation[attr] = false;
        }
    }
});
_.extend(ModelBase.prototype, EntitiesBase.UnsavedChangesHandlingMixin);
_.extend(ModelBase.prototype, EntitiesBase.NestedEntitiesHandlingMixin);

var PageableCollectionBase = Backbone.PageableCollection.extend({
    constructor: function(models, options) {
        this.cid = _.uniqueId('c');
        Backbone.PageableCollection.prototype.constructor.call(this, models, options);
    },
    setQueryParam: function (keysOrObj, value) {
        var self = this;
        function setKey (key, value) {
            if (_.isUndefined(value) || _.isNull(value)) {
                delete self.queryParams[key];
            } else {
                self.queryParams[key] = value;
            }
        }
        if (_.isObject(keysOrObj)) {
            _.each(keysOrObj, function (value, key, list) {
                setKey(key, value);
            });
        } else {
            setKey(keysOrObj, value);
        }
    },
    _prepareModel: function (attrs, options) {
        if (attrs instanceof Backbone.Model) return attrs;
        options = options ? _.clone(options) : {};
        options.collection = this;
        var model;
        if (_.isFunction(this.createModel)) {
            model = this.createModel.call(this, attrs, options);
        } else {
            model = new this.model(attrs, options);
        }
        if (!model.validationError) return model;
        this.trigger('invalid', this, model.validationError, options);
        return false;
    },
    queryParams: {
        pageSize: 'per_page',
        currentPage: 'page',
        sortKey: 'orderby',
        order: 'order'
    },
    state: {
        pageSize: 50,
        order: EntitiesBase.SORT_DIRECTIONS.DESC
    },
    parseState: function (resp, queryParams, state, options) {
        function getValueFromResponseHeader(keyName) {
            if (options.xhr) {
                var parsed = parseInt(options.xhr.getResponseHeader(keyName), 10);
                if (isNaN(parsed)) {
                    return 0;
                } else {
                    return parsed;
                }
            } else {
                return 0;
            }
        }
        return {
            totalRecords: getValueFromResponseHeader('X-WP-Total'),
            totalPages: getValueFromResponseHeader('X-WP-TotalPages')
        };
    },
    sync: function (method, model, options) {
        var beforeSend, success,
            self = this;

        options = options || {};
        beforeSend = options.beforeSend;
        options.beforeSend = function (xhr) {

            if (method === 'read') {

                var fetchEnded = function () {
                    self.fetching = false;
                    self.trigger('fetch:end', self);
                    self.off('sync error', fetchEnded);
                    self.off('request', fetchStarted);
                };

                var fetchStarted = function (model, xhr) {
                    self.fetching = true;
                    self.trigger('fetch:start', self);
                };

                self.on('request', fetchStarted);
                self.on('sync error', fetchEnded);
                self.on('sync error', fetchEnded);
            }

            if (!_.isUndefined(farmacy.settings.restAPI.nonce)) {
                xhr.setRequestHeader('X-WP-Nonce', farmacy.settings.restAPI.nonce);
            }

            if (beforeSend) {
                return beforeSend.apply(self, arguments);
            }
        };
        return Backbone.PageableCollection.prototype.sync(method, model, options);
    }
});
_.extend(PageableCollectionBase.prototype, EntitiesBase.CollectionNavigationMixin);
_.extend(PageableCollectionBase.prototype, EntitiesBase.MoveableItemsMixin);
_.extend(PageableCollectionBase.prototype, EntitiesBase.CollectionChangesTrackingMixin);
module.exports = {
    CollectionBase: EntitiesBase.CollectionBase,
    PageableCollectionBase: PageableCollectionBase,
    ModelBase: ModelBase,
    SORT_DIRECTIONS: EntitiesBase.SORT_DIRECTIONS
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/base_rest.js
 **/